import React from 'react';
import './BrandAmbassadors.css';

const BrandAmbassadors = () => {
  const ambassadors = [
    { id: 1, name: 'Kimi Räikkönen', year: '2024', icon: '🏎️' },
    { id: 2, name: 'Jasprit Bumrah', year: '2023 - 2024', icon: '🏏' },
    { id: 3, name: 'Yusrun Albudin', year: '2023', icon: '⚽' },
    { id: 4, name: 'Yashra Sagar', year: '2023', icon: '🏏' },
    { id: 5, name: 'Manisha Mohandri', year: '2022 - 2023', icon: '🎬' }
  ];

  return (
    <section className="brand-ambassadors">
      <h2 className="section-title">Brand Ambassadors</h2>
      <div className="ambassadors-grid">
        {ambassadors.map((ambassador) => (
          <div key={ambassador.id} className="ambassador-card">
            <div className="ambassador-icon">{ambassador.icon}</div>
            <div className="ambassador-info">
              <h3>{ambassador.name}</h3>
              <p>{ambassador.year}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BrandAmbassadors;
